<script setup lang="ts">
import NavigationHeader from '@/common/components/molecules/navigationHeader/NavigationHeader.vue';
import TopBanner from '@/common/components/molecules/topBanner/TopBanner.vue';
import { setup } from './baseViewport.setup';

const { isLoading, viewportOption, viewportClassName, isAnalysisViewport, isBrowserPopup } =
  setup();
</script>

<template>
  <base-menu v-if="viewportOption.useBaseMenu && !isBrowserPopup" />

  <div :class="[viewportClassName, { 'main-viewport--analysis': isAnalysisViewport }]">
    <navigation-header
      v-if="viewportOption.useNavigationHeader && !isBrowserPopup"
      use-path
    />
    <top-banner />

    <router-view v-slot="{ Component, route }">
      <keep-alive>
        <component
          :is="Component"
          v-if="viewportOption.useKeepAlive"
          :key="
            viewportOption.useRouterKey || route.meta.remountOnPathChange ? route.path : undefined
          "
        />
      </keep-alive>

      <component
        :is="Component"
        v-if="!viewportOption.useKeepAlive"
        :key="
          viewportOption.useRouterKey || route.meta.remountOnPathChange ? route.fullPath : undefined
        "
      />
    </router-view>
  </div>

  <ev-loading v-model="isLoading" />
</template>

<style lang="scss">
.main-viewport + .slide-detail {
  .slide-out-window {
    z-index: $on-slide-out-window + 1;
  }
}
.main-viewport--analysis {
  .app-header.navigation-header {
    border-bottom: 1px solid var(--color-gray-05-05);
    box-shadow: none;
  }
}
.error-viewport {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  padding-left: 30%;
  overflow: hidden;
  background-image: url('@/common/assets/error-background.svg');
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
